import { Typography } from '@mui/material';

export type PriceSpanProps = {
  price: number,
  size?: 'small' | 'regular',
  color?: string,
  showZeroKop?: boolean,
  zeroAsDash?: boolean,
  isApproximate?: boolean,
  coloring?: boolean,
};

const PriceSpan = ({ price, size, color: overrideColor, showZeroKop, zeroAsDash, isApproximate, coloring }: PriceSpanProps) => {
  if (coloring && overrideColor) {
    console.warn('PriceSpan: color prop is ignored when coloring is true');
  }

  const color = overrideColor || (price < 0 ? 'error' : undefined);

  if (zeroAsDash && price === 0) {
    return (
      <Typography variant={size === 'small' ? 'body1' : 'h6'} fontWeight={500} component='span' color={color}>
        -
      </Typography>
    );
  }
  const sign = price < 0 ? -1 : 1; 
  const absPrice = Math.abs(price);
  const rub = Math.floor(absPrice);
  const kop = ((absPrice - rub) * 100).toFixed(0).padStart(2, '0');
  const rubStr = new Intl.NumberFormat('ru-RU').format(sign * rub);
  const currencyColor = color ?? 'grey.500';
  return (
    <>
      <Typography variant={size === 'small' ? 'body1' : 'h6'} fontWeight={500} component='span' color={color}>
        {isApproximate && <Typography component='span' color={currencyColor}>~</Typography>}{rubStr}
      </Typography>

      <Typography variant="caption" component='span' color={currencyColor}>
        р.
      </Typography>

      {(showZeroKop === true || kop !== '00') &&
        <>
          <Typography variant="body2" component='span' color={color}>
            {kop}
          </Typography>
          {/* &nbsp; */}
          <Typography variant="caption" component='span' color={currencyColor}>
            к.
          </Typography>
        </>
      }

    </>
  );
};

export default PriceSpan;
